export default "__VITE_ASSET__fadbefdd__"